document.addEventListener('DOMContentLoaded', function () {
    // Function to extract and click button by variant ID from the URL
    function clickButtonByVariantId() {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        const variantIdFromUrl = url.searchParams.get('variant');

        if (variantIdFromUrl) {
            const button = document.querySelector(`button[data-variant-id="${variantIdFromUrl}"]`);
            if (button) {
                button.click();
            } else {
                // Use MutationObserver to wait for the button to appear
                const observer = new MutationObserver(() => {
                    const newButton = document.querySelector(`button[data-variant-id="${variantIdFromUrl}"]`);
                    if (newButton) {
                        newButton.click();
                        observer.disconnect();
                    }
                });
                observer.observe(document.body, { childList: true, subtree: true });
            }
        }
    }

    setTimeout(clickButtonByVariantId, 500);

    // Currency symbol based on default currency
    const currencySymbol = {
        'USD': '$',
        'EUR': '€',
        'GBP': '£',
        'PLN': 'zł',
        'RON': 'lei'
    }[defaultCurrency] || '';

    // Function to determine if the symbol should be after the price
    function isSymbolAfterPrice(currency) {
        return ['PLN', 'RON', 'EUR'].includes(currency); // Adjust as needed
    }

    // Format price function
    function formatPrice(price) {
        if (isNaN(price)) return '';

        // Convert cents to standard currency format
        let normalizedPrice = price / 100;

        // Format price based on currency locale
        let formattedPrice;

        if (['PLN', 'RON', 'EUR'].includes(defaultCurrency)) {
            formattedPrice = new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: defaultCurrency,
                minimumFractionDigits: 2
            }).format(normalizedPrice).replace(/\s/g, ''); // Remove spaces
        } else {
            formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: defaultCurrency,
                minimumFractionDigits: 2
            }).format(normalizedPrice);
        }

        // Remove any default currency symbols from formatted string
        formattedPrice = formattedPrice.replace(/[^\d.,]/g, '');

        // Apply correct currency symbol positioning
        return isSymbolAfterPrice(defaultCurrency) 
            ? `${formattedPrice} ${currencySymbol}`  // PLN, RON, EUR: 1.999,00 €
            : `${currencySymbol}${formattedPrice}`;  // USD, GBP: $1,999.00
    }

    // Get the product container that holds the Klarna and VAT data
    const productContainer = document.querySelector('.product');

    // Extract Klarna and VAT values from data attributes
    const splitPaymentOptionsElement = document.getElementById('split_payment_options');
    let splitPaymentOptions = parseFloat(productContainer?.getAttribute('data-klarna-price')) || 3; // Default to 3 if not available
    const vatAmount = parseFloat(productContainer?.getAttribute('data-exvatprice')) || 1.2;

    // Listen for change in the select dropdown for split payment options
    if (splitPaymentOptionsElement) {
        splitPaymentOptionsElement.addEventListener('change', function() {
            splitPaymentOptions = parseFloat(this.value); // Get selected value
            // Update Klarna payment on split option change
            updateKlarnaPayment(parseFloat(document.getElementById('product-price').innerText.replace(/[^\d.-]/g, '')));
        });
    }

    // Update Klarna payment price
    function updateKlarnaPayment(price) {
        const klarnaPriceElement = document.getElementById('product-klarna-price');
        if (klarnaPriceElement) {
            klarnaPriceElement.innerText = formatPrice(price / splitPaymentOptions);
        }
    }

    // Update iWocaPay price
    function updateIwocaPrice(price) {
        const iwocaElement = document.getElementById('product-iwoca-price');
        if (iwocaElement) {
            iwocaElement.innerText = formatPrice(price / 12);
        }
    }


    // Update Ex VAT price
    function updateExvatPrice(price) {
        const exvatElement = document.getElementById('exvat-amount');
        if (exvatElement) {
            exvatElement.innerText = formatPrice(price / vatAmount);
        }
    }

    // Select all variant buttons and add event listeners
    const variantButtons = document.querySelectorAll('.variant-button');

    if (variantButtons.length > 0) {
        variantButtons.forEach(button => {
            button.addEventListener('click', function () {
                variantButtons.forEach(btn => btn.classList.remove('selected'));
                this.classList.add('selected');

                const price = parseFloat(this.getAttribute('data-price')) || 0;
                const compareAtPrice = parseFloat(this.getAttribute('data-compare-at-price')) || 0;

                document.getElementById('product-price').innerText = formatPrice(price);

                // Update Klarna and Ex VAT prices regardless of the compare at price
                updateKlarnaPayment(price);
                updateExvatPrice(price);

                if (compareAtPrice > price) {
                    document.getElementById('compare-at-price').style.display = 'inline';
                    document.getElementById('saving-amount').style.display = 'inline';
                    document.getElementById('saving-container').style.display = 'inline';
                    document.getElementById('compare-at-price').innerText = formatPrice(compareAtPrice);
                    document.getElementById('saving-amount').innerText = formatPrice(compareAtPrice - price);
                } else {
                    document.getElementById('compare-at-price').style.display = 'none';
                    document.getElementById('saving-amount').style.display = 'none';
                    document.getElementById('saving-container').style.display = 'none';
                }
            });
        });
    }


  // Handle variant <select> dropdown change
const variantSelect = document.getElementById('variant-select');

if (variantSelect) {
    variantSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];

        const price = parseFloat(selectedOption.getAttribute('data-price')) || 0;
        const compareAtPrice = parseFloat(selectedOption.getAttribute('data-compare-at-price')) || 0;

        // Update product price
        document.getElementById('product-price').innerText = formatPrice(price);

        // Update Klarna, Ex VAT, and iWocaPay prices
        updateKlarnaPayment(price);
        updateExvatPrice(price);
        updateIwocaPrice(price);

        // Compare at price logic
        if (compareAtPrice > price) {
            document.getElementById('compare-at-price').style.display = 'inline';
            document.getElementById('saving-amount').style.display = 'inline';
            document.getElementById('saving-container').style.display = 'inline';
            document.getElementById('compare-at-price').innerText = formatPrice(compareAtPrice);
            document.getElementById('saving-amount').innerText = formatPrice(compareAtPrice - price);
                    
        } else {
            document.getElementById('compare-at-price').style.display = 'none';
            document.getElementById('saving-amount').style.display = 'none';
            document.getElementById('saving-container').style.display = 'none';
        }

        // Optional: Update featured image if needed
        const imageUrl = selectedOption.getAttribute('data-image');
        const imageEl = document.querySelector('.product-featured-image img');
        if (imageUrl && imageEl) {
            imageEl.src = imageUrl;
        }
    });

    // Trigger change on page load to reflect default variant
    variantSelect.dispatchEvent(new Event('change'));
}

});
